import { PropsWithChildren, useContext } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { Button } from 'src/modules/common/components/Button/Button';
import { MESSAGES } from 'src/modules/common/constants';
import { RuntimeContext } from 'src/runtimeContext';

type Props = PropsWithChildren<{
    title: string;
    result: string;
    unit: string;
    onClick: () => void;
}>;

export const CalculatorModalMainSection = ({ title, result, unit, children, onClick }: Props) => {
    const { isMobile } = useContext(RuntimeContext);

    return (
        <div className="vss-calculator-modal-main-section">
            <div className="vss-calculator-modal-main-section__controls">
                {children}

                <Button kind="tertiary" onClick={onClick} fullWidth={isMobile}>
                    <I18n messageId={MESSAGES.Reset}/>
                </Button>
            </div>

            <div className="vss-calculator-modal-main-section__result">
                <h3 className="vss-calculator-modal-main-section__title">
                    <I18n messageId={title}/>
                </h3>

                <div className="vss-calculator-modal-main-section__value-container">
                    <p className="vss-calculator-modal-main-section__value">
                        {result}
                    </p>

                    <span className="vss-calculator-modal-main-section__unit">
                        <I18n messageId={unit}/>
                    </span>
                </div>

            </div>
        </div>
    );
};
